import * as React from 'react';
import {Main} from "../components/Main";
import {CheckBox, FormField, RequiredLegend, focusFirstInvalid, WYMAGANIA_HASLA, HINT_MIGRACJA} from "../components/sharedComponents/Forms";
import Services from "../utilities/Services";
import {Box} from "../components/sharedComponents/Box";
import {notify} from "../utilities/notify";
import InputMask from "react-input-mask";
import {isEmpty, validateNip} from "../utilities/Utilities";
import Req from "../components/Req";
import axios from "axios";

interface MatchParams {
    path: string;
}

export interface RouteComponentProps<MatchParams> {
    match: any;
    history: any;
}

interface State {

    isCompany: boolean,
    setCompany: boolean,
    isRegister: boolean,
    migracja: boolean,
    repeatPass: any,
    inputValues: any,
    oddzialy: any,
    kraje: any,
    loading: boolean,
    rejestracja: boolean,
    nipInvalid: any,
    nipMessage: string,
    migrationRest: any,
    loginError: boolean
    loginErrorMessage: any,
    loadingWeryfikacja: boolean,
    bladHasla: string | null,
    bladPowtorzenia: string | null
}

interface Props extends RouteComponentProps<MatchParams> {
}

const LAB = 'col-sm-2 pr-0';
const POLE = 'col-sm-10';
const LINK_REGULAMINU = <a href={'/regulamin'} target={'_blank'} rel={'noopener noreferrer'}>Regulamin programu lojalnościowego Karta Stałego Klienta (otwiera się w nowej karcie)</a>;

export class Register extends React.Component<Props, State> {

    formularz = React.createRef<HTMLFormElement>();
    naglowekSukcesu = React.createRef<HTMLHeadingElement>();

    constructor(props: any) {
        super(props);

        this.state = {
            isCompany: false,
            setCompany: false,
            isRegister: false,
            nipInvalid: false,
            nipMessage: '',
            migracja: false,
            repeatPass: '',
            oddzialy: [],
            loginError: false,
            loginErrorMessage: false,
            loadingWeryfikacja: false,
            bladHasla: null,
            bladPowtorzenia: null,
            kraje: [],
            loading: false,
            rejestracja: false,
            migrationRest: [],
            inputValues:
                {
                    "login": "",
                    "konto_zablokowane": 0,
                    "nazwa_top": "",
                    "numer_magazynu": '',
                    "kraj": "PL",
                    "kraj_firma": "PL",
                    "zgoda_regulamin": 0,
                    "zgoda_wiek16": 0,
                    "zgoda_newsletter": 0,
                    "zgoda_karta": 0,
                    "zgoda_push": 0,
                    "pole_imie": "",
                    "pole_nazwisko": "",
                    "pole_firma": "",
                    "pole_firma_kontynuacja": "",
                    "pole_ulica": "",
                    "pole_nr_domu": "",
                    "pole_nr_mieszkania": "",
                    "pole_kod_pocztowy": "",
                    "pole_miejscowosc": "",
                    "pole_telefon": "",
                    "pole_nip": "",
                    "czy_firma": false,
                    "top_kod_sprzedawcy": '',
                    "password": "",
                    "email": "",
                    "id": ''
                }
        }

    }

    componentDidMount() {
        let {match} = this.props;

        if (match)
            if (match.params)
                if (match.params.migracja)
                {
                    if(match.params.migracja === 'migracja'){
                        if(sessionStorage.getItem('migrationData')){
                            this.setState({migracja: true});
                            this.przygotujDaneDoMigracji(JSON.parse(String(sessionStorage.getItem('migrationData'))))
                        }
                    }
                }

        this.pobierzOddzialy();
        this.pobierzKrajeFirma();
    }

    componentDidUpdate(_prevProps: Props, prevState: State) {
        if (!prevState.isRegister && this.state.isRegister && this.naglowekSukcesu.current) {
            this.naglowekSukcesu.current.focus();
        }
    }

    ustawTypKonta = (firma: boolean) => {
        if (firma !== this.state.isCompany) {
            this.setState({isCompany: firma});
            this.czyscPola();
        }
    }

    przygotujDaneDoMigracji = (migrationData: any) => {
        let data = {
            "login": this.returnValue(migrationData.login, ''),
            "konto_zablokowane": 0,
            "nazwa_top": this.returnValue(migrationData.nazwa_top, ''),
            "numer_magazynu": (isEmpty(migrationData.numer_magazynu) || (migrationData.numer_magazynu === 0)) ? 71 : migrationData.numer_magazynu,
            "kraj": (migrationData.typMigracji === 'migration/editoTop')? 'PL' : this.returnValue(migrationData.kraj, 'PL'),
            "kraj_firma": this.returnValue(migrationData.kraj_firma, 'PL'),
            "zgoda_regulamin": 0,
            "zgoda_wiek16": migrationData.zgoda_wiek16,
            "zgoda_newsletter": migrationData.zgoda_newsletter,
            "zgoda_karta": migrationData.zgoda_karta,
            "zgoda_push": migrationData.zgoda_push,
            "pole_imie": this.returnValue(migrationData.pole_imie, ''),
            "pole_nazwisko": this.returnValue(migrationData.pole_nazwisko, ''),
            "pole_firma": this.returnValue(migrationData.pole_firma, ''),
            "pole_firma_kontynuacja": this.returnValue(migrationData.pole_firma_kontynuacja, ''),
            "pole_ulica": this.returnValue(migrationData.pole_ulica, ''),
            "pole_nr_domu": this.returnValue(migrationData.pole_nr_domu, ''),
            "pole_nr_mieszkania": this.returnValue(migrationData.pole_nr_mieszkania, ''),
            "pole_kod_pocztowy": this.returnValue(migrationData.pole_kod_pocztowy, ''),
            "pole_miejscowosc": this.returnValue(migrationData.pole_miejscowosc, ''),
            "pole_telefon": this.returnValue(migrationData.pole_telefon, ''),
            "pole_nip": this.returnValue(migrationData.pole_nip, ''),
            "czy_firma": (this.returnValue(migrationData.pole_nip, '').length > 0),
            "top_kod_sprzedawcy": '',
            "password": this.returnValue(migrationData.haslo, ''),
            "email": this.returnValue(migrationData.login, ''),
            "id": this.returnValue(migrationData.id, '0')
        }

        if (data.czy_firma){
            this.setState({isCompany: true});
            data.pole_imie='';
            data.pole_nazwisko='';


        } else {
            this.setState({isCompany: false});
            data.pole_firma='';
            data.pole_firma_kontynuacja='';
            data.pole_nip='';

        }

        this.setState({inputValues: data, repeatPass: '', migrationRest: migrationData});
        sessionStorage.removeItem('migrationData');
    }

    returnValue = (val: any, defVal: string) => {
        if (isEmpty(val)){
            return defVal;
        } else {
            return String(val);
        }

    };

    handleOnChange = (e: React.FormEvent<HTMLInputElement>) => {
        const {name, value}: any = e.target;
        let input = this.state.inputValues;

        if(name === 'login'){
            input[name] = value.toLowerCase();
        } else {
            input[name] = value;
        }

        if (name === 'password') this.setState({bladHasla: null});
        this.setState({inputValues: input});
    };

    handleOnChecked = (e: React.FormEvent<HTMLInputElement>) => {
        const {name, checked}: any = e.target;
        let input = this.state.inputValues;
        input[name] = checked? 1 : 0;
        this.setState({inputValues: input});
    };

    handleOnChangerepeatPass = (e: React.FormEvent<HTMLInputElement>) => {
        const {value}: any = e.target;
        this.setState({repeatPass: value, bladPowtorzenia: null});
    }

    pobierzKrajeFirma = () => {
        this.setState({loading: true});

        Services.getKrajeFirma().then((response) => {

            console.log("get Kraje ok");

            this.setState({kraje: response.data});

        }).catch((error) => {
                this.setState({loading: false});
                console.log('get Kraje error');
            }
        )
    }

    pobierzOddzialy = () => {
        this.setState({loading: true});

        Services.getOddzialyRegister().then((response) => {

                console.log("get Oddzialy ok");

            this.setState({oddzialy: response.data, loading: false});

                // this.setState({oddzialy: response.data.sort(
                //         (a: any, b: any) => {
                //             return a.adres.localeCompare(
                //                 b.adres,
                //             );
                //         },
                //     ).map((oddzial: any) => {return oddzial}), loading: false});

            }).catch((error) => {
                this.setState({loading: false});
                console.log('get Oddzialy error');
            }
        )
    }

    onChangeKrajFirma = (e: any) => {
        //@ts-ignore
        console.log(e.target.value);

        let input = this.state.inputValues;
        input['kraj_firma']=e.target.value;
        this.setState({inputValues: input});

        if(this.state.inputValues.pole_nip.length > 0){
            this.checkNip();
        } else {
            this.setState({nipInvalid: true, nipMessage: 'Podaj NIP'});
        }

    }

    onChangeSklep = (e: any) => {
        //@ts-ignore
        console.log(e.target.value);

        let input = this.state.inputValues;
        input['numer_magazynu']=e.target.value;
        this.setState({inputValues: input});
    }

    submitForm = (e: React.FormEvent<any>) => {
        e.preventDefault()

        // if (!this.state.isCompany)
        // {
        //     let input = this.state.inputValues;
        //     input['topNazwa']=input['firma'].slice(0, 20);
        //     this.setState({inputValues: input});
        // }

        const data = this.state.inputValues;

        data['email'] = data.login;
        data['czy_firma'] = this.state.isCompany? 1 : 0;
        data['numer_magazynu'] = Number(data['numer_magazynu']);
        // data['pole_kod_pocztowy'] = data.pole_kod_pocztowy.replace('_','');

        if(this.state.migracja){
            this.setState({rejestracja: true});
            this.Migruj(data);
        } else {
            if (data.password === this.state.repeatPass) {
                this.setState({rejestracja: true, bladHasla: null, bladPowtorzenia: null});

                Services.SprawdzHaslo(data.password).then((response) => {
                    if (response.status === 200) {
                        this.Rejestruj(data);
                    }
                }).catch((error) => {
                    const komunikat = (error.response && error.response.data.message) || 'Hasło nie spełnia wymagań.';
                    notify.error(komunikat, 'Błąd rejestracji');
                    this.setState({rejestracja: false, bladHasla: komunikat}, () => focusFirstInvalid(this.formularz.current));
                })
            } else {
                notify.error('Podane hasła są różne', 'Błąd rejestracji');
                this.setState({bladPowtorzenia: 'Podane hasła są różne.'}, () => focusFirstInvalid(this.formularz.current));
            }
        }
    }

    Migruj = (data: any) => {
        let login = this.state.migrationRest.login;
        let haslo = this.state.migrationRest.haslo;
        let typMi = this.state.migrationRest.typMigracji;

        Services.Migracja(data, typMi).then((response) => {

                Services.Zaloguj(login, haslo).then((response) => {

                    let token = 'Basic ' + btoa(login + ':' + haslo)

                    axios.defaults.headers.common.Authorization = token;

                    sessionStorage.setItem('isUserLoggedMM',
                        JSON.stringify(Object.assign({}, response.data, {token: token}))
                    )

                    window.location.replace('/konto');

                }).catch(error => {
                    notify.error(error.response.data.message, 'Błąd logowania');
                    window.location.replace('/login');
                })

            }).catch((error) => {

            notify.error(error.response.data.message, 'Błąd aktualizacji danych');
            this.setState({rejestracja: false});

        })
    }

    Rejestruj = (data: any) => {

        Services.Register(data)
            .then((response) => {
                if (response.status === 200) {

                    this.setState({isRegister: true, rejestracja: false});

                }
            }).catch((error) => {

            notify.error(error.response.data.message, 'Błąd rejestracji');
            this.setState({rejestracja: false});

        })

    }

    changeTypKonta = (e: any) => {
        let input = this.state.inputValues;
        input['czy_firma'] = e.checked;
        this.setState({inputValues: input});
    }

    czyscPola() {

        if(!this.state.migracja){
            this.setState({inputValues:
                    {
                        "login": "",
                        "konto_zablokowane": 0,
                        "nazwa_top": "",
                        "numer_magazynu": '',
                        "kraj": "PL",
                        "kraj_firma": "PL",
                        "zgoda_regulamin": 0,
                        "zgoda_wiek16": 0,
                        "zgoda_newsletter": 0,
                        "zgoda_karta": 0,
                        "zgoda_push": 0,
                        "pole_imie": "",
                        "pole_nazwisko": "",
                        "pole_firma": "",
                        "pole_firma_kontynuacja": "",
                        "pole_ulica": "",
                        "pole_nr_domu": "",
                        "pole_nr_mieszkania": "",
                        "pole_kod_pocztowy": "",
                        "pole_miejscowosc": "",
                        "pole_telefon": "",
                        "pole_nip": "",
                        "czy_firma": this.state.isCompany,
                        "top_kod_sprzedawcy": '',
                        "password": "",
                        "email": "",
                        "id": ''
                    }, repeatPass: '', nipInvalid: false, nipMessage: '', loginErrorMessage: false}
            )
        }
    }

    checkNip = () => {
        if(this.state.inputValues.pole_nip.length > 0){
            Services.WeryfikujNip(this.state.inputValues.kraj_firma, this.state.inputValues.pole_nip).then((response) => {
                this.setState({nipMessage: response.data.message});
                if(response.data.countryValid === false && response.data.euValid === false){
                    this.setState({nipInvalid: true});
                } else {
                    this.setState({nipInvalid: false});
                }
            }).catch((e) => {
                this.setState({nipInvalid: true, nipMessage: e.response.data.message});
            })
        } else {
            this.setState({nipInvalid: true, nipMessage: 'Podaj NIP'});
        }

        // if (validateNip(this.state.inputValues.pole_nip)) {
        //     this.setState({nipInvalid: false});
        // } else {
        //     this.setState({nipInvalid: true})
        // }
    }

    sprawdzLogin = () => {
        if (!this.state.inputValues.login) return;
        if(!this.state.migracja){
            this.setState({loadingWeryfikacja: true});
            Services.weryfikujLogin(this.state.inputValues.login).then((response) => {
                this.setState({loginError: false, loadingWeryfikacja: false, loginErrorMessage: true});
            }).catch((e) => {
                this.setState({loginError: true, loginErrorMessage: e.response.data.message, loadingWeryfikacja: false});
            })
        }
    }

    poleTelefon = () =>
        <FormField label={'Telefon:'} required labelCol={LAB} fieldCol={POLE}>
            <input type={'text'} className={'form-control'} value={this.state.inputValues.pole_telefon}
                   onChange={this.handleOnChange} name={'pole_telefon'} autoComplete={'tel'}/>
        </FormField>

    polaAdresuISklepu = () => {
        let {inputValues, oddzialy} = this.state;
        return <>
            <FormField label={'Kod pocztowy:'} required labelCol={LAB} fieldCol={POLE}>
                <InputMask mask={[/\d/, /\d/, '-', /\d/, /\d/, /\d/]} className={'form-control'} style={{maxWidth: '120px', marginBottom: '10px'}}
                           value={inputValues.pole_kod_pocztowy} onChange={this.handleOnChange} name={'pole_kod_pocztowy'}
                           minLength={5} autoComplete={'postal-code'}/>
            </FormField>
            <FormField label={'Miejscowość:'} required labelCol={LAB} fieldCol={POLE}>
                <input type={'text'} className={'form-control'} value={inputValues.pole_miejscowosc} onChange={this.handleOnChange}
                       maxLength={50} name={'pole_miejscowosc'} autoComplete={'address-level2'}/>
            </FormField>
            <FormField label={'Nazwa ulicy:'} labelCol={LAB} fieldCol={POLE}>
                <input type={'text'} className={'form-control'} value={inputValues.pole_ulica} onChange={this.handleOnChange}
                       maxLength={40} name={'pole_ulica'} autoComplete={'address-line1'}/>
            </FormField>
            <FormField label={'Nr domu:'} required labelCol={LAB} fieldCol={POLE}>
                <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}} value={inputValues.pole_nr_domu}
                       onChange={this.handleOnChange} name={'pole_nr_domu'}/>
            </FormField>
            <FormField label={'Nr mieszkania:'} labelCol={LAB} fieldCol={POLE}>
                <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}} value={inputValues.pole_nr_mieszkania}
                       onChange={this.handleOnChange} name={'pole_nr_mieszkania'}/>
            </FormField>
            <FormField label={'Twój sklep:'} required labelCol={LAB + ' mb-3'} fieldCol={POLE + ' mb-3'}>
                <select className={'form-control'} onChange={this.onChangeSklep} value={inputValues.numer_magazynu}>
                    <option value={''} disabled hidden>Wybierz twój sklep...</option>
                    {oddzialy.map((oddzial: any) => (
                        <option key={oddzial.numag} value={oddzial.numag}>{oddzial.adresPelen}</option>
                    ))}
                </select>
            </FormField>
            <FormField label={'Numer Sprzedawcy polecającego:'} labelCol={'col-sm-10 my-auto pr-0 text-right'} fieldCol={'col-sm-2 my-auto'}>
                <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}} value={inputValues.top_kod_sprzedawcy}
                       onChange={this.handleOnChange} name={'top_kod_sprzedawcy'}/>
            </FormField>
            <div className={'col-sm-12'} style={{marginBottom: '25px'}}/>
            <div className={'col-sm-12'}>
                <CheckBox required={true} name={'zgoda_regulamin'} checked={inputValues.zgoda_regulamin} handleOnChange={this.handleOnChecked}
                          label={<><Req/> Oświadczam, iż zapoznałem się i akceptuję {LINK_REGULAMINU}</>}/>
            </div>
        </>
    }

    zgodyMarketingowe = () => {
        let {inputValues} = this.state;
        return <>
            <div className={'col-sm-12'}>
                <CheckBox required={false} name={'zgoda_newsletter'} checked={inputValues.zgoda_newsletter} handleOnChange={this.handleOnChecked}
                          label={'Zgodnie z art. 6 ust. 1 lit. a) RODO wyrażam zgodę na przetwarzanie moich danych osobowych w celu subskrypcji newslettera Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie.'}/>
            </div>
            <div className={'col-sm-12'}>
                <CheckBox required={false} name={'zgoda_push'} checked={inputValues.zgoda_push} handleOnChange={this.handleOnChecked}
                          label={'Wyrażam zgodę na używanie telekomunikacyjnych urządzeń końcowych (np. telefonu) dla celów marketingu bezpośredniego przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie.'}/>
            </div>
        </>
    }

    render() {
        let {inputValues, isCompany, isRegister, repeatPass, rejestracja, migracja, nipInvalid, nipMessage, kraje,
            loginError, loginErrorMessage, loadingWeryfikacja, bladHasla, bladPowtorzenia} = this.state;
        const hintMigracji = migracja ? HINT_MIGRACJA : undefined;

        return (
            (!isRegister) ?
                <Main active={'REGISTER'} title={(migracja) ? 'Aktualizacja danych' : 'Rejestracja'}>
                    <Box>
                        <h1 className={'h3'}>{(migracja) ? 'Aktualizacja danych' : 'Rejestracja'}</h1>
                        {(migracja) ?
                            <p>Uzupełnij brakujące informacje o koncie.</p>
                            :
                            <p>W celu rejestracji wprowadź poprawnie swoje dane, po ich wysłaniu otrzymasz wiadomość z linkiem do
                                pobrania aplikacji mobilnej Merkury Market.</p>
                        }
                        <form onSubmit={this.submitForm.bind(this)} ref={this.formularz}>
                            <section className={'register-form'}>
                                <RequiredLegend/>
                                <div className={'row'}>
                                    <FormField label={'Login (e-mail):'} required labelCol={LAB} fieldCol={POLE}
                                               hint={hintMigracji}
                                               error={(!loadingWeryfikacja && loginError) ? <>{loginErrorMessage} <a href={'/login'}>Zaloguj się</a></> : null}
                                               status={loadingWeryfikacja ?
                                                   <><i className="fa fa-spinner fa-spin" aria-hidden={'true'}/> weryfikacja...</>
                                                   : (loginErrorMessage === true ? <><i className="fa fa-check" aria-hidden={'true'}/> Login OK</> : null)}>
                                        <input type={'email'} className={'form-control'} value={inputValues.login}
                                               onChange={this.handleOnChange} disabled={migracja} onBlur={() => this.sprawdzLogin()}
                                               autoComplete={'email'} name={'login'}/>
                                    </FormField>

                                    {(!migracja) && <>
                                        <FormField label={'Hasło:'} required labelCol={LAB} fieldCol={POLE} hint={WYMAGANIA_HASLA} error={bladHasla}>
                                            <input type={'password'} className={'form-control'} value={inputValues.password}
                                                   onChange={this.handleOnChange} name={'password'} autoComplete={'new-password'}/>
                                        </FormField>
                                        <FormField label={'Powtórz hasło:'} required labelCol={LAB} fieldCol={POLE} error={bladPowtorzenia}>
                                            <input type={'password'} className={'form-control'} value={repeatPass}
                                                   onChange={this.handleOnChangerepeatPass} autoComplete={'new-password'}/>
                                        </FormField>
                                    </>}

                                    <div className={LAB}>
                                        <span id={'typ-konta-etykieta'}>Typ konta:</span>
                                    </div>
                                    <div className={POLE} style={(migracja) ? {lineHeight: '38px'} : undefined}>
                                        {(migracja) ?
                                            ((isCompany) ? 'Firma' : 'Osoba fizyczna')
                                            :
                                            <div className={'radio-line'} role={'radiogroup'} aria-labelledby={'typ-konta-etykieta'}>
                                                <input type={'radio'} checked={!isCompany} onChange={() => this.ustawTypKonta(false)}
                                                       name={'typKonta'} value={'osoba'} id={'person'}/> <label htmlFor="person">Osoba fizyczna</label>
                                                <input type={'radio'} checked={isCompany} onChange={() => this.ustawTypKonta(true)}
                                                       name={'typKonta'} value={'firma'} id={'company'}/> <label htmlFor="company">Firma</label>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {isCompany ?
                                    <div className={'row'}>
                                        <FormField label={'Nazwa skrócona:'} required labelCol={LAB} fieldCol={POLE}
                                                   hint={<>Maksymalnie 20 znaków.{migracja && <> {HINT_MIGRACJA}</>}</>}>
                                            <input type={'text'} className={'form-control'} value={inputValues.nazwa_top} disabled={migracja}
                                                   maxLength={20} onChange={this.handleOnChange} name={'nazwa_top'}/>
                                        </FormField>
                                        <FormField label={'Kraj:'} required labelCol={LAB + ' mb-3'} fieldCol={POLE + ' mb-3'}>
                                            <select className={'form-control'} onChange={this.onChangeKrajFirma} value={inputValues.kraj_firma}>
                                                <option value={''} disabled>Wybierz kraj...</option>
                                                {kraje.map((kraj: any) => (
                                                    <option key={kraj.value} value={kraj.value}>{kraj.label}</option>
                                                ))}
                                            </select>
                                        </FormField>
                                        <FormField label={'NIP:'} required labelCol={LAB} fieldCol={POLE}
                                                   hint={<>Jeżeli jesteś obcokrajowcem z obszaru EU podaj nip europejski VAT EU.{migracja && <> {HINT_MIGRACJA}</>}</>}
                                                   error={nipInvalid ? nipMessage : null}
                                                   status={(!nipInvalid && nipMessage) ? nipMessage : null}>
                                            <input type={'text'} pattern="[0-9]*" className={'form-control'} value={inputValues.pole_nip}
                                                   onBlur={() => this.checkNip()} onChange={this.handleOnChange} disabled={migracja} name={'pole_nip'}/>
                                        </FormField>
                                        <FormField label={'Firma:'} required labelCol={LAB} fieldCol={POLE} hint={hintMigracji}>
                                            <input type={'text'} className={'form-control'} value={inputValues.pole_firma} maxLength={90}
                                                   onChange={this.handleOnChange} disabled={migracja} name={'pole_firma'} autoComplete={'organization'}/>
                                        </FormField>
                                        <FormField label={'Firma c.d.:'} labelCol={LAB} fieldCol={POLE} hint={hintMigracji}>
                                            <input type={'text'} className={'form-control'} value={inputValues.pole_firma_kontynuacja} disabled={migracja}
                                                   maxLength={90} onChange={this.handleOnChange} name={'pole_firma_kontynuacja'}/>
                                        </FormField>
                                        {this.poleTelefon()}
                                        {this.polaAdresuISklepu()}
                                        {this.zgodyMarketingowe()}
                                    </div>
                                    :
                                    <div className={'row'}>
                                        <FormField label={'Imię:'} required labelCol={LAB} fieldCol={POLE}>
                                            <input type={'text'} className={'form-control'} value={inputValues.pole_imie}
                                                   onChange={this.handleOnChange} name={'pole_imie'} autoComplete={'given-name'}/>
                                        </FormField>
                                        <FormField label={'Nazwisko:'} required labelCol={LAB} fieldCol={POLE}>
                                            <input type={'text'} className={'form-control'} value={inputValues.pole_nazwisko}
                                                   onChange={this.handleOnChange} name={'pole_nazwisko'} autoComplete={'family-name'}/>
                                        </FormField>
                                        {this.poleTelefon()}
                                        {this.polaAdresuISklepu()}
                                        <div className={'col-sm-12'}>
                                            <CheckBox required={true} name={'zgoda_wiek16'} checked={inputValues['zgoda_wiek16']} handleOnChange={this.handleOnChecked}
                                                      label={<><Req/> Oświadczam, iż posiadam co najmniej 16 lat</>}/>
                                        </div>
                                        <div className={'col-sm-12'}>
                                            <CheckBox required={true} name={'zgoda_karta'} checked={inputValues['zgoda_karta']} handleOnChange={this.handleOnChecked}
                                                      label={<><Req/> Zgodnie z art. 6 ust. 1 lit. a) Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia Dyrektywy 95/46/WE (Dz. Urz. UE L 119 z 04.05.2016) – dalej RODO, wyrażam zgodę na przetwarzanie moich danych osobowych w celach związanych z realizacją programu lojalnościowego Karta Stałego Klienta przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie.</>}/>
                                        </div>
                                        {this.zgodyMarketingowe()}
                                    </div>
                                }
                            </section>
                            <div className={'buttons-line'}>
                                <button type={'submit'} className={'btn btn-custom-secondary'} disabled={rejestracja || loginError}>{(migracja) ? ((rejestracja) ? <><i className="fa fa-spinner fa-spin" aria-hidden={'true'}/> zapisywanie...</> : 'Zapisz') : ((rejestracja) ? <><i className="fa fa-spinner fa-spin" aria-hidden={'true'}/> trwa rejestracja...</> : 'Zarejestruj')}</button>
                            </div>
                        </form>
                        <hr/>
                        <div>
                        <small>Zgodnie z art. 13 RODO Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w
                            Krośnie informuje, że:
                            1) administratorem Pani/Pana danych osobowych jest Merkury Market Spółka z ograniczoną
                            odpowiedzialnością Sp.k. z siedzibą w Krośnie (ul. Czajkowskiego 51, 38-400 Krosno),
                            2) Pani/Pana dane osobowe przetwarzane będą dla potrzeb obsługi programu lojalnościowego Karty
                            Stałego
                            Klienta - na podstawie art. 6 ust. 1 lit. a) RODO, w przypadku wyrażenia zgody pkt 4 - Pani/Pana
                            dane
                            osobowe przetwarzane będą w celu subskrypcji newslettera na podstawie art. 6 ust. 1 lit. a) RODO, a
                            w
                            przypadku wyrażenia zgody pkt 5 - Pani/Pana dane osobowe przetwarzane będą dla celów marketingu
                            bezpośredniego na podstawie art. 6 ust. 1 lit. f) RODO,
                            3) Pana/Pani dane osobowe będą przetwarzane do dnia cofnięcia udzielonych powyżej zgód na
                            przetwarzanie
                            danych osobowych, jednak nie dłużej niż: (i) w przypadku wyrażenia zgody na przetwarzanie danych
                            osobowych w celach związanych z realizacją programu lojalnościowego Karty Stałego Klienta – przez
                            okres
                            uczestnictwa w programie, a po tym czasie w zakresie wymaganym przez przepisy prawa lub dla
                            zabezpieczenia ewentualnych roszczeń, (ii) w przypadku wyrażenia zgody na przetwarzanie danych
                            osobowych
                            w celu subskrypcji newslettera - nie dłużej niż do dnia żądania usunięcia z subskrypcji, (iii) w
                            przypadku wyrażenia zgody na używanie telekomunikacyjnych urządzeń końcowych – nie dłużej niż do
                            czasu
                            wniesienia sprzeciwu wobec przetwarzania,
                            4) posiada Pani/Pan prawo do żądania od Administratora dostępu do danych osobowych, prawo do ich
                            sprostowania, usunięcia lub ograniczenia przetwarzania, prawo do wniesienia sprzeciwu wobec
                            przetwarzania, prawo do przenoszenia danych, prawo do cofnięcia zgody w dowolnym momencie,
                            5) ma Pani/Pan prawo wniesienia skargi do organu nadzorczego,
                            6) ma Pani/Pan prawo do kontaktu z Inspektorem Ochrony Danych Osobowych pod adresem:
                            inspektor@merkurymarket.pl,
                            7) podanie danych osobowych jest warunkiem wydania Karty Stałego Klienta lub korzystania z tej
                            Karty, w
                            przypadku wyrażenia zgody pkt 4 i 5 - podanie danych osobowych jest dobrowolne,
                            8) Pani/Pana dane będą przetwarzane w sposób zautomatyzowany, w tym również w formie profilowania –
                            dotyczy subskrypcji newslettera.</small>
                    </div>
                    </Box>
                </Main>
                :
                <Main active={'REGISTER'} title={'Rejestracja zakończona'}>
                    <Box>
                        <h1 className={'h3'} style={{color: 'green'}} ref={this.naglowekSukcesu} tabIndex={-1}><i className="fa fa-check" style={{color: 'green'}} aria-hidden={'true'}/> Dziękujemy za rejestrację !</h1>
                        <p>Na podany adres e-mail została wysłana wiadomość z linkiem aktywacyjnym.</p>
                    </Box>
                </Main>
        );
    }

}

export default Register;


